import React from "react";
import "../css/Topbar.scss";

export default () => {
  return (
    <header className="topbar">
      <div className="inner">TodoThis</div>
    </header>
  );
};
